export default {
  ENTERPRISE_SECTION_ID: 'enterprise-section',
  MOBILE_APP_ID: 'mobile-app',
  LETS_TALK_ID: 'lets-talk',
};
